import type { ChainSlug } from '../types/chains.js';

/** Shared mutable reference to the current default chain. */
export class ChainRef {
  current?: ChainSlug;

  constructor(initial?: ChainSlug) {
    this.current = initial;
  }
}
